module.exports = window["wcStripeModules"]["messageModules"];